import {eatalianoAxios} from "@/data/api/http/axios";
import {RestaurantLocation, UpdateFulfillmentStatusFields} from "@/data/entities/restaurant";

export const getRestaurantLocations = (): Promise<RestaurantLocation[]> => (
    eatalianoAxios
        .get("/restaurant")
        .then(response => response.data)
);

export const updateFulfillmentStatus = (
    restaurantId: number,
    fields: UpdateFulfillmentStatusFields,
): Promise<RestaurantLocation[]> => (
    eatalianoAxios
        .patch(`/restaurant/${restaurantId}/fulfillment`, fields)
        .then(response => response.data)
);